import { useSearchParams } from 'next/navigation';

import { useOverlayItem } from '@flipster/overlay';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';
import { PusdtCurrency, UsdtCurrency } from '@flipster/utils/constants/currency';

import { CurrencyDisplay } from '../../misc/display';
import TradingVolumeRewardTiersContent from './content';

interface Props {
  currency?: string;
  buttonText?: string;
  onClose?: () => void;
}

const TradingVolumeRewardTiersModal = ({ currency: currencyProp, buttonText, onClose }: Props) => {
  const { onClose: onCloseModal } = useOverlayItem();

  const searchParams = useSearchParams();
  const currencyParam = searchParams.get('currency') ?? UsdtCurrency;
  const currency = currencyProp ?? currencyParam;

  return (
    <Modal>
      <Modal.Close onClose={onCloseModal} />
      <Modal.Header>
        <div>
          <CurrencyDisplay
            currency={currency}
            icon={<CurrencyDisplay.Icon size={24} />}
            mainLabel={
              <span className={css({ textStyle: 'Text/M/Strong', color: 'content.default.level-4' })}>
                {currency === PusdtCurrency ? 'Premium Earn' : currency}
              </span>
            }
          />
        </div>
        <Modal.Title label='Increase trading volume and upgrade rewards' />
      </Modal.Header>
      <Modal.Content>
        <TradingVolumeRewardTiersContent currency={currency} />
      </Modal.Content>
      <Modal.Footer>
        <Button
          onClick={() => {
            onClose?.();
            onCloseModal();
          }}
          label={buttonText ?? 'Dismiss'}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default TradingVolumeRewardTiersModal;
